/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventPipMinimizeFromJSON(json) {
    return StreemApiAnalyticEventPipMinimizeFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventPipMinimizeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !exists(json, 'user') ? undefined : json['user'],
        'side': !exists(json, 'side') ? undefined : json['side'],
    };
}
export function StreemApiAnalyticEventPipMinimizeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': value.user,
        'side': value.side,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPipMinimizeUser;
(function (StreemApiAnalyticEventPipMinimizeUser) {
    StreemApiAnalyticEventPipMinimizeUser["LOCAL"] = "PIP_USER_TYPE_LOCAL";
    StreemApiAnalyticEventPipMinimizeUser["REMOTE"] = "PIP_USER_TYPE_REMOTE";
    StreemApiAnalyticEventPipMinimizeUser["INVALID"] = "PIP_USER_TYPE_INVALID";
})(StreemApiAnalyticEventPipMinimizeUser || (StreemApiAnalyticEventPipMinimizeUser = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPipMinimizeSide;
(function (StreemApiAnalyticEventPipMinimizeSide) {
    StreemApiAnalyticEventPipMinimizeSide["LEFT"] = "PIP_SIDE_LEFT";
    StreemApiAnalyticEventPipMinimizeSide["RIGHT"] = "PIP_SIDE_RIGHT";
    StreemApiAnalyticEventPipMinimizeSide["INVALID"] = "PIP_SIDE_INVALID";
})(StreemApiAnalyticEventPipMinimizeSide || (StreemApiAnalyticEventPipMinimizeSide = {}));
//# sourceMappingURL=StreemApiAnalyticEventPipMinimize.js.map